import { useSearchParams } from 'react-router';
import { LIBELLE_STATUT, type StatutDocument } from '@/api/types';

const STATUTS = Object.keys(LIBELLE_STATUT) as string[];

/**
 * Onglet et filtre de statut d'une liste de dossiers, portés par l'URL (`?onglet=…`, `?statut=…`) : le tableau de bord
 * peut ainsi ouvrir une liste déjà filtrée, et le bouton « Précédent » du navigateur retrouve le filtre.
 *
 * @param onglets onglets proposés à l'utilisateur (dans l'ordre d'affichage)
 * @param defaut onglet ouvert sans paramètre
 * @param ongletStatut onglet qui porte le filtre de statut (un statut dans l'URL l'impose)
 */
export function useFiltresListe<O extends string>(onglets: readonly O[], defaut: O, ongletStatut: O) {
  const [params, setParams] = useSearchParams();
  const s = params.get('statut');
  const statut: StatutDocument | 'TOUS' = s && STATUTS.includes(s) ? (s as StatutDocument) : 'TOUS';
  const o = params.get('onglet');
  const onglet: O = statut !== 'TOUS' ? ongletStatut : o && (onglets as readonly string[]).includes(o) ? (o as O) : defaut;
  const setOnglet = (v: O) => setParams(v === defaut ? {} : { onglet: v }, { replace: true });
  const setStatut = (v: StatutDocument | 'TOUS') => setParams(v === 'TOUS' ? (ongletStatut === defaut ? {} : { onglet: ongletStatut }) : { statut: v }, { replace: true });
  return { onglet, statut, setOnglet, setStatut };
}
